import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function PhotodynamicTherapyUseCase() {
  return (
    <>
    <section
      id="photodynamic-therapy"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Photodynamic Therapy (PDT)
          </h1>
          <p className="text-slate-300 space-y-2">
            Photodynamic therapy is a targeted medical treatment that uses light-activated compounds called photosensitisers to destroy diseased cells, typically in cancer and antimicrobial applications. 
            Upon activation by a specific light wavelength, the photosensitiser produces reactive oxygen species (ROS) that selectively damage nearby biological tissue.

            <br /><br />

            Key material requirements include strong absorption in the therapeutic window (typically 600–800 nm), efficient ROS generation (e.g., singlet oxygen), high photostability, low dark toxicity, and rapid clearance from healthy tissues. 
            Molecular design must balance solubility, targeting capability, and excited-state dynamics to ensure effectiveness and safety.

            <br /><br />

            PDT continues to gain traction in oncology, dermatology, and antimicrobial therapies due to its minimally invasive nature and spatial precision.
          </p>
        </div>

        {/* How Apoello Helps */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">How Apoello Helps</h2>
          <ul className="list-disc list-inside text-slate-300 space-y-2">
            <li>
              Search millions of organic molecules by absorption wavelength, triplet state energy, and singlet oxygen generation potential.
            </li>
            <li>
              Identify promising sensitiser scaffolds that absorb in the therapeutic window (600–800 nm).
            </li>
            <li>
              Evaluate photostability, solubility, and excited-state lifetimes.
            </li>
            <li>
              Order candidates for lab testing.
            </li>
          </ul>
        </div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            Photodynamic therapy shows great potential in precision medicine, but the development of new photosensitisers is time-consuming and costly. 
            DiaDEM™ enables rapid in silico screening of next-generation PDT agents — reducing trial-and-error in synthesis and helping bring safer, more effective therapies to clinical use.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
